export default function hlsLoader() {
  return new Promise((resolve, reject) => {
    if (window.Hls) {
      resolve(window.Hls)
    } else {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.src = 'https://cdn.jsdelivr.net/npm/hls.js@latest'
      script.onerror = reject
      script.onload = () => {
        resolve(window.Hls)
      }
      document.head.appendChild(script)
    }
    // window.initAMap = () => {
    //   resolve(window.AMap)
    // }
  })
}
